import { Component } from 'react';
import styled from 'styled-components';
import { fontSize } from '@/public/template/common/css/setting/variable';

const Wrapper = styled.div`
  padding: 40px 16px;
  font-size: ${fontSize.px14};
  text-align: center;

  /* カテゴリトップなどでニュースフィードの追加読み込みに失敗した時 */
  .newsFeed_list + & {
    border-top: 1px solid ${props => props.theme.news.palette.bor_lv2_pc};
  }
`;

const ModuleErrorTitle = styled.strong`
  font-weight: normal;
`;
const ModuleErrorExplain = styled.p`
  margin-top: 4px;
  font-size: ${fontSize.px14};
  line-height: 1.3;
  color: ${({ theme }) => theme.news.palette.text_sub_lv1_common};
`;
const ModuleErrorLink = styled.p`
  margin-top: 8px;
`;

interface IProps {
  title: string;
  explain?: JSX.Element | string;
  additionalComponent?: JSX.Element;
}
export default class ModuleError extends Component<IProps> {
  /**
   *
   */
  public render(): JSX.Element {
    return (
      <Wrapper>
        <ModuleErrorTitle>{this.props.title}</ModuleErrorTitle>
        {this.props.explain ? <ModuleErrorExplain>{this.props.explain}</ModuleErrorExplain> : null}
        {this.props.additionalComponent ? <ModuleErrorLink>{this.props.additionalComponent}</ModuleErrorLink> : null}
      </Wrapper>
    );
  }
}
